var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileOutlineDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.583 5.417C14.583 7.917 12.5 10 10 10S5.417 7.917 5.417 5.417 7.5.833 10 .833s4.583 2.084 4.583 4.584Zm-2.5 0A2.063 2.063 0 0 0 10 3.333a2.063 2.063 0 0 0-2.083 2.084C7.917 6.583 8.833 7.5 10 7.5a2.063 2.063 0 0 0 2.083-2.083ZM2.5 16.667c0-2.75 2.25-5 5-5h5c2.75 0 5 2.25 5 5v2.5H15v-2.5c0-1.417-1.167-2.5-2.5-2.5h-5c-1.333 0-2.5 1.083-2.5 2.5v2.5H2.5v-2.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOutlineDark);
export default __webpack_public_path__ + "static/media/profile-outline-dark.9df37615b13662468159a9399dd48ab6.svg";
export { ForwardRef as ReactComponent };